import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	FormGroup,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
} from 'reactstrap';
import $ from 'jquery';
import AppPage from '../../views/AppPage/';
import CKEditor from 'ckeditor4-react';
const GLOBAL = require('../../Globals');

class EditPage extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			title: '',
			url: '',
			pagestatus: '',
			showapp: '',
			order: '',
			mkey: '',
			mdesc: '',
			_message: '',
			alertClass: '',
			posts: '',
		}
		this.updateContent = this.updateContent.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onShowAppChange = this.onShowAppChange.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onOrderChange = this.onOrderChange.bind(this);
	}

	updateContent(evt) {
		var newContent = evt.editor.getData();
		this.setState({
			content: newContent
		})
	}

	onOrderChange(e) {

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].orderno == e.target.value) {

				alert('Order Number Was Already Alloted.');
				$("#btnSavePage").attr('disabled', true);
			}
			else {

				$("#btnSavePage").attr('disabled', false);
			}
		}
		this.setState({ order: e.target.value });
	}

	/** redirect to All Pages **/
	onBack(e) {

		this.setState({ _redirect: true });
	}

	onShowAppChange(e) {

		if (e.target.checked) {

			this.setState({ showapp: 1 });
			$("#orderno").show(1000);
		}
		else {

			this.setState({ showapp: 0 });
			$("#orderno").hide(1000);
		}
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onSubmit(e) {
		e.preventDefault();

		// this.state.url = $("#txtslug").val();
		$("#showLoader").show();
		PostData('page/editpage', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Page Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.getdetails();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	componentWillMount() {

		this.getdetails();
		this.getdata();
	}

	getdata() {

		GetData('page/getpage').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	getdetails() {
		$("#showLoader").show();
		GetData('page/getpagebyid/' + this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					title: res[0]['title'],
					url: res[0]['slug'] + '.html',
					content: res[0]['content'],
					pagestatus: res[0]['pagestatus'],
					showapp: res[0]['isapp'],
					order: res[0]['orderno'],
					mkey: res[0]['metakeyword'],
					mdesc: res[0]['metadescription']
				});
			}
		});
	}

	render() {

		this.state.id = this.props.match.params.id;

		if (this.state._redirect) {

			return (<Redirect to={'/page/allpage'} />);

		}

		/** set status select box **/
		this.pstatus = [
			{ value: '', name: 'Select' },
			{ value: 'active', name: 'Active' },
			{ value: 'deactive', name: 'Deactive' }
		];

		$("#pageTitle").keyup(function () {

			var sl = $(this).val();
			$("#txtslug").val(sl.replace(/ /g, '-').toLowerCase() + ".html");
		});

		$("#btnChangeSlug").click(function () {
			$("#txtslug").prop('disabled', false);
		});

		$("#txtslug").blur(function () {
			$(this).prop('disabled', true);
		});

		if (this.state.showapp == 1) {

			$("#isapp").prop("checked", true);
			$("#orderno").show(1000);
		}
		else {

			$("#isapp").prop("checked", false);
			$("#orderno").hide(1000);
		}

		return (
			<div>
				<AppPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="pageform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="9">
								<Card>
									<CardHeader>
										<strong>Edit Page</strong>
										<Button outline color="primary" className="btn-right" onClick={this.onBack}>Back</Button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Page Title </Label>
													<Input type="text" name="title" id="pageTitle" onChange={this.onChange} value={this.state.title} />
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<InputGroup>
														<InputGroupAddon addonType="prepend">
															<InputGroupText>
																{GLOBAL.BASE_URL}
															</InputGroupText>
														</InputGroupAddon>
														<Input type="text" name="url" id="txtslug" onChange={this.onChange} placeholder="my-page.html" value={this.state.url} disabled />
														<InputGroupAddon addonType="append">
															<Button type="button" id="btnChangeSlug" >Edit</Button>
														</InputGroupAddon>
													</InputGroup>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Page Content </Label>
													<CKEditor
														data={this.state.content}
														onChange={this.updateContent}
														config={{ extraPlugins: 'iframe', extraAllowedContent: '*(*);*{*}', allowedContent: true }}
													/>
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col md="3">
								<Card>
									<CardHeader>
										<strong>Meta</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Status</Label>
													<select name="pagestatus" className="form-control" onChange={this.onChange} value={this.state.pagestatus}>
														{this.pstatus.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<input type="checkbox" name="showapp" id="isapp" onChange={this.onShowAppChange} />&nbsp;&nbsp;Show On App
							</FormGroup>
											</Col>
											<Col md="12" id="orderno" style={{ display: 'none' }}>
												<FormGroup>
													<Label htmlFor="name">Order Number</Label>
													<Input type="text" name="order" id="orno" onChange={this.onOrderChange} value={this.state.order} />
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Meta Keyword</Label>
													<Input type="textarea" name="mkey" onChange={this.onChange} rows="4" value={this.state.mkey} />
												</FormGroup>
											</Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name">Meta Description</Label>
													<Input type="textarea" name="mdesc" onChange={this.onChange} rows="5" value={this.state.mdesc} />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" id="btnSavePage" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		);
	}
}

export default EditPage;


// WEBPACK FOOTER //
// ./src/page/Pages/EditPage.js